module.exports = __webpack_public_path__ + "static/media/key-performance-indicator (1).3fe7bb3a.png";